import { chatBot } from '@/constants/pages';
import { Box, Collapse, IconButton, Typography } from '@mui/material';
import { IconSparkles } from '@tabler/icons-react';
import { useEffect, useState } from 'react';

type AnimatedVaniButtonProps = {
  isLoading?: boolean;
};

const AnimatedVaniButton = ({ isLoading = false }: AnimatedVaniButtonProps) => {
  const [isAskVaniOpen, setIsAskVaniOpen] = useState(false);
  const [counter, setCountrer] = useState(0);
  useEffect(() => {
    if (!isLoading && counter < 2) {
      var timer = setTimeout(
        () => {
          setCountrer((prev) => prev + 1);
          setIsAskVaniOpen((prev) => !prev);
        },
        counter ? 6000 : 350,
      );
      return () => clearTimeout(timer);
    }
    return () => clearTimeout(timer);
  }, [isLoading, isAskVaniOpen, counter]);

  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
    >
      <Box
        display='flex'
        marginRight='0'
      >
        <Collapse
          in={isAskVaniOpen}
          timeout={350}
          orientation='horizontal'
          sx={{
            display: 'flex',
            marginRight: '-20px',
          }}
        >
          <Box
            display='flex'
            sx={{
              cursor: 'pointer',
              backgroundColor: 'custom.chatBotLLM.headerBgColor',
              color: 'custom.onAccentColor',
              borderRadius: '25px 0 0 25px',
              padding: '12px 20px',
            }}
          >
            <Typography
              sx={{ minWidth: '70px' }}
            >{`Ask ${chatBot.title}`}</Typography>
          </Box>
        </Collapse>
        <Box
          display='flex'
          sx={{
            cursor: 'pointer',
            backgroundColor: 'custom.chatBotLLM.headerBgColor',
            color: 'custom.onAccentColor',
            borderRadius: '25px',
          }}
        >
          <IconButton
            size='large'
            sx={{
              backgroundColor: 'custom.chatBotLLM.headerBgColor',
              color: 'custom.onAccentColor',
              ['&:hover']: {
                backgroundColor: 'custom.chatBotLLM.headerBgColor',
              },
            }}
          >
            <IconSparkles />
          </IconButton>
        </Box>
      </Box>
      {/* <Box sx={{ width: '100%' }}>
        <Collapse
          orientation='horizontal'
          in={!isAskVaniOpen && counter > 1}
          timeout={350}
          sx={{
            backgroundColor: 'custom.chatBotLLM.headerBgColor',
            marginLeft: '-20px',
            paddingX: 1,
            borderRadius: 1,
            paddingY: 0.5,
          }}
        >
          <Box
            display='flex'
            alignItems='center'
          >
            <Typography
              sx={{
                minWidth: '70px',
                color: 'custom.onAccentColor',
                lineHeight: '1',
              }}
            >
              {`Ask ${chatBot.title}`}
            </Typography>
          </Box>
        </Collapse>
      </Box> */}
    </Box>
  );
};

export default AnimatedVaniButton;
